import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DairyCollectionDetailedReport } from './Pages/listing';

export const DairyCollectionDetailedReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DairyCollectionDetailedReport} />
    </Fragment>
)